import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {MaterialCancellationResult} from "../types/MaterialCancellationResult";

export const useRequestMaterialCancellation = (
	materialOrderID: number,
	onSuccess: (result: MaterialCancellationResult) => void,
	onError: (error: string) => void
) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("material-order/request-cancellation",
				{ materialOrderID: materialOrderID }) as MaterialCancellationResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when submitting the cancellation requested: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
